import { useSDK } from "@/components/context/sdk-provider";

import { useTenantConfig } from "@/lib/hooks";

function HeaderSkeleton() {
  return (
    <header className="bg-background flex w-full items-center justify-center border-b px-4 py-4 md:px-8">
      <div className="container max-w-6xl">
        <div className="flex items-center justify-center">
          <div className="h-10 w-32 animate-pulse rounded bg-gray-200" />
        </div>
      </div>
    </header>
  );
}

export function Header() {
  const { data, isLoading } = useTenantConfig();

  if (isLoading) {
    return <HeaderSkeleton />;
  }

  return (
    <header className="bg-background flex w-full items-center justify-center border-b px-4 py-4 md:px-8">
      <div className="container max-w-6xl">
        <div className="flex items-center justify-center">
          {data?.logoUrl ? (
            <a
              href="#"
              onClick={(e) => e.preventDefault()}
              aria-label={data?.brandName}
            >
              <img
                src={data?.logoUrl}
                alt={data?.brandName}
                className="h-10 w-auto rounded-lg"
              />
            </a>
          ) : (
            <h1 className="text-xl font-semibold">{data?.brandName}</h1>
          )}
        </div>
      </div>
    </header>
  );
}
